import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

interface DetachDriverModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDetach: (reason: string) => void;
  driverName?: string;
  loading?: boolean;
}

const DetachDriverModal: React.FC<DetachDriverModalProps> = ({
  isOpen,
  onClose,
  onDetach,
  driverName,
  loading = false
}) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (reason.trim()) {
      onDetach(reason.trim());
    }
  };

  const handleClose = () => {
    setReason('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title={t('modals.detachDriver.title')}>
      <form onSubmit={handleSubmit} className="modal-form">
        {driverName && (
          <div style={{ marginBottom: '1rem', padding: '1rem', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
            <strong>{t('modals.detachDriver.currentDriver')}:</strong> {driverName}
          </div>
        )}

        <div className="modal-form-group">
          <label htmlFor="reason">{t('modals.detachDriver.reasonLabel')}</label>
          <textarea
            id="reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder={t('modals.detachDriver.reasonPlaceholder')}
            required
            disabled={loading}
          />
        </div>

        <div className="modal-actions">
          <button
            type="button"
            onClick={handleClose}
            className="modal-button secondary"
            disabled={loading}
          >
            {t('modals.detachDriver.cancel')}
          </button>
          <button
            type="submit"
            className="modal-button danger"
            disabled={loading || !reason.trim()}
          >
            {loading ? t('modals.detachDriver.detaching') : t('modals.detachDriver.detach')}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default DetachDriverModal;
